import { render, staticRenderFns } from "./ImportTemplate.vue?vue&type=template&id=3d4bd221&scoped=true"
import script from "./ImportTemplate.vue?vue&type=script&lang=js"
export * from "./ImportTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4bd221",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d4bd221')) {
      api.createRecord('3d4bd221', component.options)
    } else {
      api.reload('3d4bd221', component.options)
    }
    module.hot.accept("./ImportTemplate.vue?vue&type=template&id=3d4bd221&scoped=true", function () {
      api.rerender('3d4bd221', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/payableManage/bankPaymentManagement/bradesco/cmp/ImportTemplate.vue"
export default component.exports